import { render } from "./slide.vue?vue&type=template&id=4fec0822&scoped=true&lang=pug"
import script from "./slide.vue?vue&type=script&lang=js"
export * from "./slide.vue?vue&type=script&lang=js"

import "./slide.vue?vue&type=style&index=0&id=4fec0822&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fec0822"]])

export default __exports__